import { Formik } from 'formik';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../../common/helpers/translate.helper';
import { useAssignmentCreate } from '../hooks/useAssignmentCreate';

import { AssignmentBaseForm, FormikAssignmentState } from './AssignmentBaseForm';
import { validateAssignment } from './validateAssignment';

interface CreateAssignmentDrawerProps {
    onSuccess: () => void;
}

export const CreateAssignmentDrawer = (props: CreateAssignmentDrawerProps) => {
    const { addErrorToast } = useToasts();

    const createAssignmentMutation = useAssignmentCreate();

    const initialValues: FormikAssignmentState = {
        customerId: '',
        supplierId: '',
    };

    const handleSubmit = async (values: FormikAssignmentState) => {
        const requestMessage = {
            customerId: values.customerId,
            supplierId: values.supplierId,
        };

        try {
            await createAssignmentMutation.mutateAsync(requestMessage);
            props.onSuccess();
        } catch {
            addErrorToast(translate('assignments.toasts.createError'));
        }
    };

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validateAssignment}>
            <AssignmentBaseForm primaryActionText={translate('assignments.create')} />
        </Formik>
    );
};
